import { APIService } from "../Service/API.Service";

/**
 * Client for the server's `/admin/*` surface (super-admin tooling).
 * Currently only the widget-harness SMS-inject proxy (ENG-2991); the rest
 * of the admin controller is INTERNAL-only and has no browser callers.
 */
export class AdminAPI {
  /**
   * Swivl-admin — simulate an inbound SMS from a user. Proxied by the main
   * server to the bot's INTERNAL `/sms/inject`. The bot's reply is a REAL
   * outgoing SMS to the user's phone — test users only.
   */
  static async smsInject(orgId: number, userId: number, body: string) {
    return APIService.Server.post<AdminSmsInjectResult>(`/admin/sms-inject`, { orgId, userId, body });
  }

  /**
   * Server-side leg of the proxy above: apps/server → bot with the internal
   * token (`APIService.Bot` is configured in the server's bootstrap). Same
   * pattern as ContactCenterRelay.API's bot calls.
   */
  static async smsInjectViaBot(orgId: number, userId: number, body: string) {
    return APIService.Bot.post<AdminSmsInjectResult>(`/sms/inject`, { orgId, userId, body });
  }
}

/** Mirrors the bot server's InjectInboundResult (apps/bot SMS.Controller). */
export type AdminSmsInjectResult =
  | { ok: true; from: string; to: string; messageSid: string }
  | { ok: false; reason: "no_phone_on_user" | "no_twilio_app_for_org" };
